import { gridRowGap, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateAreas, gridTemplateColumns, gridTemplateRows, compose } from "styled-system";
import { gridColumnGap } from "@sonos-inc/web-ui-styled-system";
import styled from "@sonos-inc/web-ui-styled";
import css from "@sonos-inc/web-ui-css";
import { BlockStyles } from "@sonos-inc/web-ui-block";
export var GridStyles = [compose(BlockStyles, gridColumnGap, gridRowGap, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateAreas, gridTemplateColumns, gridTemplateRows), css({
  display: "grid"
})];
/**
 * The Grid component is a 2-dimensional system, meaning it can handle both columns and rows, unlike flexbox which is largely a 1-dimensional system!
 *
 * Define rows and columns with the **gridTemplateColumns** and **gridTemplateRows** properties. These define grid tracks. A grid track is the space between any two lines on the grid.
 *
 * Gutters or alleys between grid cells can be created using the **gridColumnGap** and **gridRowGap** properties, or the shorthand **gridGap**.
 *
 * The **gridAutoFlow** property controls how the auto-placement algorithm works, specifying exactly how auto-placed items get flowed into the grid.
 */

export var Grid = styled.div(GridStyles);
Grid.displayName = "Grid";
export default Grid;